// src/AppContent.js

import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion"; // ✅ NEW!
import Library from "./Pages/Library";
import Reader from "./Pages/Reader";
import Quiz from "./Pages/Quiz";
import ReadingList from "./Pages/ReadingList";
import Landing from "./Pages/Landing";
import TopNav from "./Components/TopNav";
import BookDetails from "./Pages/BookDetails";
import Roadmap from './Pages/Roadmap';

function AppContent() {
  const location = useLocation();
  const hideNavOnLanding = location.pathname === "/";

  return (
    <>
      {!hideNavOnLanding && <TopNav />}

      {/* ✅ Wrap your Routes in AnimatePresence */}
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<Landing />} />
          <Route path="/library" element={<Library />} />
          <Route path="/reader/:chapterId" element={<Reader />} />
          <Route path="/quiz" element={<Quiz />} />
          <Route path="/reading-list" element={<ReadingList />} />
          <Route path="/book/:bookId" element={<BookDetails />} />
          <Route path="/roadmap" element={<Roadmap />} />
        </Routes>
      </AnimatePresence>
    </>
  );
}

export default AppContent;

